import { useModal } from 'context/ModalContext';
import { useRouteContext } from 'context/RouterContext';
import { PROTECTED_PATH } from 'shared/constants';
import { useLangNavigate } from 'shared/hooks';
import { getPathWithoutLang } from 'shared/lib/converter';
import { useInfoStore } from 'store/useInfoStore';

import { useScrollToTopOnNavigation } from './useScrollToTopOnNavigation';

export const useRouteChangeHandler = () => {
  const { lang, navigateWithLang } = useLangNavigate();
  const { openModal, closeModal, MODAL_TYPES } = useModal();
  const { accessToken, email } = useInfoStore();
  const { redirectPath, setRedirectPath } = useRouteContext();

  useScrollToTopOnNavigation();

  const handleRouteChange = (path: string, replace?: boolean) => {
    const isProtectedPath = PROTECTED_PATH.some((protectedPath) => path.startsWith(protectedPath));
    const isLogin = email !== '' && accessToken !== '';

    if (isProtectedPath && !isLogin) {
      setRedirectPath(path);
      openModal(MODAL_TYPES.LOGIN);
      return;
    }

    navigateWithLang(path, { replace });
  };

  // 매물 상세는 데스크톱(Tailwind md, 1280px~)에서만 새 탭으로 연다. 폰·태블릿은 인앱 브라우저 등에서 새 탭이 불편해 같은 탭 유지.
  const handleListingDetailRouteChange = (path: string) => {
    if (!window.matchMedia('(min-width: 1280px)').matches) {
      handleRouteChange(path);
      return;
    }

    window.open(lang ? `/${lang}${path}` : path, '_blank', 'noopener');
  };

  const handleLoginSuccess = () => {
    closeModal();

    // URL 파라미터에서 redirect 값 확인
    const urlParams = new URLSearchParams(window.location.search);
    const urlRedirectPath = urlParams.get('redirect');

    if (urlRedirectPath) {
      const pathWithoutLang = getPathWithoutLang(urlRedirectPath);
      navigateWithLang(pathWithoutLang);
    } else if (redirectPath) {
      // 기존 RouterContext의 redirectPath 사용
      // console.log('redirectPath', redirectPath);
      navigateWithLang(redirectPath);
      setRedirectPath(null);
    }
  };

  return { handleRouteChange, handleListingDetailRouteChange, handleLoginSuccess };
};
